import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function Home() {
  // Static category data with thumbnail images
  const categories = {
    people: {
      title: 'People',
      thumbnail: 'photos/people/EOS6D_IMG_102_5379-2.jpg',
      description: 'Portraits and candid shots of people in various settings.'
    },
    places: {
      title: 'Places',
      thumbnail: 'photos/places/EOS6D_IMG_102_3941.jpg',
      description: 'Beautiful landscapes, cityscapes, and architectural photography.'
    },
    things: {
      title: 'Things',
      thumbnail: 'photos/things/EOS6D_IMG_102_3406.jpg',
      description: 'Still life, objects, and artistic compositions.'
    },
    panorama: {
      title: 'Panorama',
      thumbnail: 'photos/panorama/wingletang-sphere.jpg',
      description: 'Immersive 360° panoramic views you can explore interactively.'
    }
  };

  // Get the current base path (e.g., /react-test or empty string for root)
  const basePath = window.location.pathname.replace(/\/$/, ''); // Remove trailing slash if present

  return (
    <Container className="w-75 mt-4">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <h1 className="mb-4">Home</h1>
          <p className="lead mb-4">
            Welcome to my photo gallery!
          </p>
          <p>
            Here you can find a selection of my favourite shots, showcasing my journey as a photographer.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col md={12}>
          <h4 className="text-center mb-4">Explore My Work</h4>
          <h6 className="text-center mb-4">(images link through to Gallery)</h6>
          
          {/* Single row with all categories */}
          <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
            {Object.entries(categories).map(([categoryKey, categoryData]) => (
              <Card 
                key={categoryKey}
                as="a"
                href={`${basePath}/gallery#${categoryKey}`}
                className="text-decoration-none border-0 shadow-sm"
                style={{ 
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              >
                <Card.Img
                  variant="top"
                  src={categoryData.thumbnail}
                  alt={`${categoryData.title} photography`}
                  className="rounded-top"
                  style={{ 
                    height: '100px',
                    width: 'auto',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
                <Card.Body className="text-center py-2">
                  <Card.Title className="text-capitalize text-dark mb-0 fs-6">
                    {categoryData.title}
                  </Card.Title>
                </Card.Body>
              </Card>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
